export const MAIN_MENU_HIDDEN_BTN_BACK = ['broadcastEmail', 'groupEmail', 'draftBroadcastEmail']

export const MAX_FILES_SIZE = 25 * 1024 * 1024; // 25 MB\

export const noNavbar = ['groupEmail', 'sendEmail', 'broadcastEmail', 'detailGroupEmail', 'detailBroadcastEmail']